import api from "../../client";
import {
  UpdateContentBoxPayload,
  UpdateContentBoxResponseData,
} from "../../types/contentBox";

export const updateContentBoxRequest = async (
  id: string,
  payload: UpdateContentBoxPayload,
): Promise<UpdateContentBoxResponseData> => {
  const { data } = await api.put<UpdateContentBoxResponseData>(
    `/content-box/${id}`,
    payload,
  );

  return data;
};
